import type * as Types from '../../../graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type DeleteProjectFilesMutationVariables = Types.Exact<{
  fileIds: Array<Types.InputMaybe<Types.Scalars['Long']['input']>> | Types.InputMaybe<Types.Scalars['Long']['input']>;
}>;


export type DeleteProjectFilesMutation = { deleteProjectFiles: boolean | null };

export type CreateProjectFolderMutationVariables = Types.Exact<{
  name: Types.Scalars['String']['input'];
  folderId: Types.Scalars['Long']['input'];
}>;


export type CreateProjectFolderMutation = { createProjectFolder: boolean | null };


export const DeleteProjectFilesDocument = gql`
    mutation deleteProjectFiles($fileIds: [Long]!) {
  deleteProjectFiles(fileIds: $fileIds)
}
    `;
export type DeleteProjectFilesMutationFn = Apollo.MutationFunction<DeleteProjectFilesMutation, DeleteProjectFilesMutationVariables>;

/**
 * __useDeleteProjectFilesMutation__
 *
 * To run a mutation, you first call `useDeleteProjectFilesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProjectFilesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProjectFilesMutation, { data, loading, error }] = useDeleteProjectFilesMutation({
 *   variables: {
 *      fileIds: // value for 'fileIds'
 *   },
 * });
 */
export function useDeleteProjectFilesMutation(baseOptions?: Apollo.MutationHookOptions<DeleteProjectFilesMutation, DeleteProjectFilesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteProjectFilesMutation, DeleteProjectFilesMutationVariables>(DeleteProjectFilesDocument, options);
      }
export type DeleteProjectFilesMutationHookResult = ReturnType<typeof useDeleteProjectFilesMutation>;
export type DeleteProjectFilesMutationResult = Apollo.MutationResult<DeleteProjectFilesMutation>;
export type DeleteProjectFilesMutationOptions = Apollo.BaseMutationOptions<DeleteProjectFilesMutation, DeleteProjectFilesMutationVariables>;
export const CreateProjectFolderDocument = gql`
    mutation createProjectFolder($name: String!, $folderId: Long!) {
  createProjectFolder(name: $name, folderId: $folderId)
}
    `;
export type CreateProjectFolderMutationFn = Apollo.MutationFunction<CreateProjectFolderMutation, CreateProjectFolderMutationVariables>;

/**
 * __useCreateProjectFolderMutation__
 *
 * To run a mutation, you first call `useCreateProjectFolderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProjectFolderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProjectFolderMutation, { data, loading, error }] = useCreateProjectFolderMutation({
 *   variables: {
 *      name: // value for 'name'
 *      folderId: // value for 'folderId'
 *   },
 * });
 */
export function useCreateProjectFolderMutation(baseOptions?: Apollo.MutationHookOptions<CreateProjectFolderMutation, CreateProjectFolderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateProjectFolderMutation, CreateProjectFolderMutationVariables>(CreateProjectFolderDocument, options);
      }
export type CreateProjectFolderMutationHookResult = ReturnType<typeof useCreateProjectFolderMutation>;
export type CreateProjectFolderMutationResult = Apollo.MutationResult<CreateProjectFolderMutation>;
export type CreateProjectFolderMutationOptions = Apollo.BaseMutationOptions<CreateProjectFolderMutation, CreateProjectFolderMutationVariables>;